export const dict = {
  "command.category.suggested": "Suggested",
  "command.category.view": "View",
  "command.category.session": "Session",
  "command.category.file": "File",
  "session.surface.mode": "Session mode",
  "session.surface.chat": "Chat",
  "session.surface.terminal": "Terminal",
  "session.surface.tui.defaultTitle": "Terminal",
  "session.tui.createFailed": "Could not create PTY session",
  "session.context.title": "Remove context",
  "session.context.select": "Select turns to remove",
  "session.context.sizeNow": "Context ≈{{current}} tokens · select turns to remove",
  "session.context.size": "Context ≈{{current}} → ≈{{next}} tokens",
  "session.context.remove": "Remove ({{count}})",
  "session.context.removed": "Removed {{count}} messages from context",
  "session.context.removeFailed": "Could not remove the selected messages",
  "session.context.loadEarlier": "Load earlier turns",
  "session.context.empty": "Nothing to remove yet",
  "session.context.compaction": "Compaction summary",
  "session.context.background": "Background result",
  "session.context.compacted": "compacted",
  "session.context.tools": "{{count}} tool calls",
  "session.context.hint": "Drag across turns to select a range · Shift-click extends · Delete removes · Esc cancels",
  "session.surface.terminal.connected": "Connected",
  "session.surface.terminal.connecting": "Connecting…",
  "session.surface.terminal.starting": "Starting terminal…",
  "session.surface.terminal.stopping": "Stopping terminal…",
  "session.surface.terminal.stopped": "Terminal stopped",
  "session.surface.terminal.exited": "Terminal exited",
  "session.surface.terminal.connectionFailed": "Terminal connection failed",
  "session.surface.terminal.createFailed": "The terminal could not be created",
  "session.surface.terminal.stopFailed": "The terminal could not be stopped",
  "session.surface.terminal.stop": "Stop",
  "session.surface.terminal.restart": "Restart",
  "session.surface.terminal.reconnect": "Reconnect",
  "command.category.model": "Model",
  "command.category.workspace": "Workspace",
  "command.category.settings": "Settings",

  "theme.scheme.system": "System",
  "theme.scheme.light": "Light",
  "theme.scheme.dark": "Dark",

  "command.sidebar.toggle": "Toggle sidebar",
  "command.settings.open": "Open settings",
  "command.session.previous": "Previous chat",
  "command.session.next": "Next chat",

  "common.pinned": "PINNED",
  "common.pin": "Pin",
  "common.unpin": "Unpin",
  "common.recent": "Recent",

  "command.session.new": "New session",
  "command.session.newTui": "New PTY",
  "command.project.open": "Open workspace",
  "command.file.open": "Open file",
  "command.terminal.toggle": "Toggle terminal",
  "command.terminal.new": "New terminal",
  "command.fileTree.toggle": "Toggle file tree",
  "command.review.toggle": "Toggle review",
  "command.model.choose": "Choose model",
  "command.model.variant.cycle": "Cycle model variant",
  "command.agent.cycle": "Cycle agent",
  "command.provider.connect": "Connect provider",
  "permission.trust.menu": "Workspace permissions",
  "permission.trust.current": "Permissions: {{level}}",
  "permission.trust.trusted.title": "Standard",
  "permission.trust.trusted.description": "Run freely in the workspace; ask before outside access.",
  "permission.trust.supervised.title": "Supervised",
  "permission.trust.supervised.description": "Ask before shell commands, file changes, and outside access.",
  "permission.trust.unrestricted.title": "Unrestricted",
  "permission.trust.unrestricted.description": "Run without permission prompts, including outside the workspace.",
  "command.session.fork": "Fork from message",
  "command.session.compact": "Compact session",
  "command.session.compact.description": "Summarize the conversation to free up context",
  "palette.empty": "No results found",

  "dialog.provider.search.placeholder": "Search providers",
  "dialog.provider.empty": "No providers found",
  "dialog.provider.opencode-go.note": "OpenCode Go models via API key. Get a key at https://opencode.ai/docs/zen",
  "dialog.model.select.title": "Select model",
  "dialog.model.search.placeholder": "Search models",
  "dialog.model.recent": "Recent",
  "dialog.model.empty": "No model results",
  "dialog.model.manage": "Manage models",


  "provider.connect.title": "Connect {{provider}}",
  "provider.connect.selectMethod": "Select login method for {{provider}}.",
  "provider.connect.method.apiKey": "API key",
  "provider.connect.status.inProgress": "Authorization in progress…",
  "provider.connect.status.waiting": "Waiting for authorization…",
  "provider.connect.status.failed": "Authorization failed: {{error}}",
  "provider.connect.apiKey.description":
    "Enter your {{provider}} API key to connect your account and use {{provider}} models in Kettle.",
  "provider.connect.apiKey.label": "{{provider}} API key",
  "provider.connect.apiKey.placeholder": "API key",
  "provider.connect.apiKey.required": "API key is required",
  "provider.connect.oauth.code.visit.prefix": "Visit ",
  "provider.connect.oauth.code.visit.link": "this link",
  "provider.connect.oauth.code.visit.suffix":
    " to collect your authorization code to connect your account and use {{provider}} models in Kettle.",
  "provider.connect.oauth.code.label": "{{method}} authorization code",
  "provider.connect.oauth.code.placeholder": "Authorization code",
  "provider.connect.oauth.code.required": "Authorization code is required",
  "provider.connect.oauth.code.invalid": "Invalid authorization code",
  "provider.connect.oauth.auto.visit.prefix": "Visit ",
  "provider.connect.oauth.auto.visit.link": "this link",
  "provider.connect.oauth.auto.visit.suffix":
    " and enter the code below to connect your account and use {{provider}} models in Kettle.",
  "provider.connect.oauth.auto.confirmationCode": "Confirmation code",
  "provider.connect.toast.connected.title": "{{provider}} connected",
  "provider.connect.toast.connected.description": "{{provider}} models are now available to use.",


  "model.tag.latest": "New",

  "common.goBack": "Navigate back",
  "common.goForward": "Navigate forward",
  "common.loading": "Loading",
  "common.loading.ellipsis": "…",
  "common.cancel": "Cancel",
  "common.disconnect": "Disconnect",
  "common.submit": "Submit",
  "common.save": "Save",
  "common.attachment": "attachment",

  "prompt.placeholder.normal": 'Ask anything... "{{example}}"',
  "prompt.placeholder.simple": "Ask anything, @tag files/folders, $use capabilities, or / for commands",
  "prompt.placeholder.mobile": "Ask anything, @ files, / commands",
  "prompt.placeholder.oracle": "Ask about past work, decisions, or context…",

  "prompt.popover.emptyResults": "No matching results",
  "prompt.popover.capabilitiesUnavailable": "Could not load capabilities",
  "prompt.popover.filesUnavailable": "Could not search files",
  "prompt.popover.emptyCommands": "No matching commands",
  "prompt.popover.chats": "Chats",
  "prompt.popover.chatsHint": "chat: shows only chats",
  "prompt.slash.badge.prompt": "prompts",
  "prompt.context.removeFile": "Remove file from context",
  "prompt.action.attachFile": "Add file",
  "prompt.attachment.remove": "Remove attachment",
  "prompt.dropzone.attach": "Drop to attach",
  "prompt.dropzone.mention": "Drop to @mention file",
  "prompt.action.send": "Send",
  "prompt.action.stop": "Stop",

  "prompt.toast.pasteUnsupported.title": "Unsupported attachment",
  "prompt.toast.pasteUnsupported.description": "Only images, PDFs, or text files can be attached here.",
  "prompt.toast.modelAgentRequired.title": "Select an agent and model",
  "prompt.toast.modelAgentRequired.description": "Choose an agent and model before sending a prompt.",
  "prompt.toast.worktreeCreateFailed.title": "Failed to create worktree",
  "prompt.toast.sessionCreateFailed.title": "Failed to create session",
  "prompt.toast.promptSendFailed.title": "Failed to send prompt",
  "prompt.toast.promptSendFailed.description": "Unable to retrieve session",


  "dialog.fork.nameLabel": "Session name",
  "dialog.fork.archiveSource": "And archive original",
  "dialog.fork.deleteSource": "And delete original",

  "dialog.directory.search.placeholder": "Search folders",
  "dialog.directory.empty": "No folders found",

  "dialog.server.title": "Servers",
  "dialog.server.search.placeholder": "Search servers",
  "dialog.server.empty": "No servers yet",
  "dialog.server.add.title": "Add server",
  "dialog.server.add.url": "Server address",
  "dialog.server.add.placeholder": "http://localhost:4096",
  "dialog.server.add.error": "Could not connect to server",
  "dialog.server.add.checking": "Checking…",
  "dialog.server.add.button": "Add server",
  "dialog.server.add.name": "Server name (optional)",
  "dialog.server.add.namePlaceholder": "Localhost",
  "dialog.server.add.username": "Username (optional)",
  "dialog.server.add.usernamePlaceholder": "username",
  "dialog.server.add.password": "Password (optional)",
  "dialog.server.add.passwordPlaceholder": "password",
  "dialog.server.edit.title": "Edit server",
  "dialog.server.menu.edit": "Edit",
  "dialog.server.menu.default": "Set as default",
  "dialog.server.menu.defaultRemove": "Remove default",
  "dialog.server.menu.delete": "Delete",
  "dialog.server.status.default": "Default",
  "server.row.noUsername": "no username",

  "context.breakdown.title": "Context Breakdown",
  "context.breakdown.note": 'Approximate breakdown of input tokens. "Other" includes tool definitions and overhead.',
  "context.breakdown.system": "System",
  "context.breakdown.user": "User",
  "context.breakdown.assistant": "Assistant",
  "context.breakdown.tool": "Tool Calls",
  "context.breakdown.other": "Other",

  "context.systemPrompt.title": "System Prompt",
  "context.rawMessages.title": "Raw messages",

  "context.stats.session": "Session",
  "context.stats.messages": "Messages",
  "context.stats.provider": "Provider",
  "context.stats.model": "Model",
  "context.stats.limit": "Context Limit",
  "context.stats.totalTokens": "Total Tokens",
  "context.stats.usage": "Usage",
  "context.stats.inputTokens": "Input Tokens",
  "context.stats.outputTokens": "Output Tokens",
  "context.stats.reasoningTokens": "Reasoning Tokens",
  "context.stats.cacheTokens": "Cache Tokens (read/write)",
  "context.stats.userMessages": "User Messages",
  "context.stats.assistantMessages": "Assistant Messages",
  "context.stats.totalCost": "Total Cost",
  "context.stats.sessionCreated": "Session Created",
  "context.stats.lastActivity": "Last Activity",

  "context.usage.tokens": "Tokens",
  "context.usage.usage": "Usage",
  "context.usage.cost": "Cost",
  "context.usage.view": "View context usage",

  "toast.project.reloadFailed.title": "Failed to reload {{project}}",

  "toast.file.loadFailed.title": "Failed to load file",
  "toast.file.listFailed.title": "Failed to list files",
  "toast.file.saveFailed.title": "Failed to save file",
  "toast.file.saveConflict.title": "File changed on disk",
  "toast.file.saveConflict.description": "Your edits were not saved. Reload to discard them, or save again to overwrite.",

  "file.load.timedOut": "File loading timed out. Check the machine connection and try again.",
  "file.load.retry": "Retry",
  "file.preview.tooLarge": "Preview unavailable: this file is too large.",
  "file.fontSize.label": "Text size",
  "file.fontSize.increase": "Increase text size",
  "file.fontSize.decrease": "Decrease text size",  "file.save.saved": "Saved",
  "file.save.conflict": "Changed on disk",
  "file.save.error": "Not saved",

  "error.page.title": "Something went wrong",
  "error.page.description": "An error occurred while loading the application.",
  "error.page.details.label": "Error details",
  "error.page.action.restart": "Restart",
  "error.page.circular": "[Circular]",
  "error.page.report.prefix": "Please report this error",
  "error.page.report.support": "to Kettle support",
  "error.page.version": "Version: {{version}}",

  "error.dev.rootNotFound":
    "Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?",

  "error.globalSDK.serverNotAvailable": "Server not available",
  "error.childStore.persistedCacheCreateFailed": "Failed to create persisted cache",
  "error.childStore.persistedProjectMetadataCreateFailed": "Failed to create persisted project metadata",
  "error.childStore.persistedProjectIconCreateFailed": "Failed to create persisted project icon",
  "error.childStore.storeCreateFailed": "Failed to create store",
  "directory.error.invalidUrl": "Invalid directory in URL.",

  "error.chain.unknown": "Unknown error",
  "error.chain.causedBy": "Caused by:",
  "error.chain.apiError": "API error",
  "error.chain.status": "Status: {{status}}",
  "error.chain.retryable": "Retryable: {{retryable}}",
  "error.chain.responseBody": "Response body:\n{{body}}",
  "error.chain.didYouMean": "Did you mean: {{suggestions}}",
  "error.chain.modelNotFound": "Model not found: {{provider}}/{{model}}",
  "error.chain.checkConfig": "Check your config (mux.json) provider/model names",
  "error.chain.mcpFailed": 'MCP server "{{name}}" failed. Note, Kettle does not support MCP authentication yet.',
  "error.chain.providerAuthFailed": "Provider authentication failed ({{provider}}): {{message}}",
  "error.chain.providerInitFailed":
    'Failed to initialize provider "{{provider}}". Check credentials and configuration.',
  "error.chain.configJsonInvalid": "Config file at {{path}} is not valid JSON(C)",
  "error.chain.configJsonInvalidWithMessage": "Config file at {{path}} is not valid JSON(C): {{message}}",
  "error.chain.configDirectoryTypo":
    'Directory "{{dir}}" in {{path}} is not valid. Rename the directory to "{{suggestion}}" or remove it. This is a common typo.',
  "error.chain.configFrontmatterError": "Failed to parse frontmatter in {{path}}:\n{{message}}",
  "error.chain.configInvalid": "Config file at {{path}} is invalid",
  "error.chain.configInvalidWithMessage": "Config file at {{path}} is invalid: {{message}}",

  "notification.permission.title": "Permission required",
  "notification.permission.description": "Permission needed in {{projectName}}",
  "notification.permission.description.detail": "{{detail}} in {{projectName}}",
  "notification.question.title": "Question",
  "notification.question.description": "Question in {{projectName}}",
  "notification.question.description.detail": "{{detail}} in {{projectName}}",
  "notification.action.goToSession": "Go to session",

  "notification.session.responseReady.title": "Response ready",
  "notification.session.error.title": "Session error",
  "notification.session.error.fallbackDescription": "An error occurred",

  "home.recentProjects": "Recent workspaces",
  "home.empty.title": "No recent workspaces",
  "home.empty.description": "Get started by opening a workspace",

  "session.tab.review": "Review",
  "session.review.loadingChanges": "Loading changes…",
  "session.review.loadFailed": "Could not load changes.",
  "session.review.retry": "Retry",
  "session.review.noChanges": "No changes",
  "session.review.group": "Group",
  "session.review.ungroup": "Ungroup",
  "session.review.grouping": "Grouping…",
  "session.review.groupHint": "Split the changed lines by kind of file",
  "session.review.oneGroup": "All changes are one kind of file.",

  "session.files.all": "Files",
  "file.tree.refresh": "Refresh files",
  "session.messages.loading": "Loading messages…",
  "session.messages.retry": "Retry",
  "session.messages.unavailable": "This session is no longer available.",

  "session.question.progress": "{{current}} of {{total}} questions",
  "session.secret.title": "Secret",
  "session.secret.value": "Value",
  "session.secret.valuePlaceholder": "Paste value",
  "session.secret.show": "Show",
  "session.secret.hide": "Hide",
  "session.secret.tooShort": "At least {{min}} characters",
  "session.secret.scope.chat": "This chat",
  "session.secret.scope.chatHint": "Until Kettle restarts · agents only see ${{name}}",
  "session.secret.scope.account": "Saved",
  "session.secret.scope.accountHint": "In Secrets, on every machine · agents only see ${{name}}",
  "session.secret.provide": "Provide",
  "session.secret.decline": "Decline",
  "session.secret.plain": "Not a secret",
  "session.secret.plainHint": "Send it in plain text; the agent sees the value",
  "session.secret.sayInstead": "Say something instead",
  "session.secret.message": "Message",
  "session.secret.messagePlaceholder": "Tell the agent what to do instead",
  "session.secret.back": "Back",
  "session.secret.send": "Send",
  "session.secret.ownerOnly": "Only the chat's owner can provide this secret.",
  "session.secret.add": "Add secret",
  "session.secret.name": "Name",
  "session.secret.nameInvalid": "Letters, digits, and _ only; no leading digit",
  "session.secret.save": "Save",
  "session.secret.scope.label": "Keep it for",
  "session.request.askedBy": "Asked by",
  "session.request.untitledChat": "a chat working for you",
  "session.followupDock.summary.one": "{{count}} queued message",
  "session.followupDock.summary.other": "{{count}} queued messages",
  "session.followupDock.sendNow": "Send now",
  "session.followupDock.sendAfter": "Send after",
  "session.followupDock.sendingNow": "Sending now…",
  "session.followupDock.starting": "Starting…",
  "session.followupDock.saving": "Saving…",
  "session.followupDock.notSent": "Not sent",
  "session.followupDock.edit": "Edit",
  "session.followupDock.waitTillDone": "Waiting until done",
  "session.followupDock.alreadySent": "Already sent",
  "session.followupDock.alreadyCancelled": "Already cancelled",
  "session.request.closed": "No longer waiting for an answer",
  "session.followupDock.collapse": "Collapse queued messages",
  "session.followupDock.expand": "Expand queued messages",

  "session.new.title": "Build anything",
  "session.new.worktree.main": "Main branch",
  "session.new.worktree.mainWithBranch": "Main branch ({{branch}})",
  "session.new.worktree.create": "Create new worktree",
  "session.new.lastModified": "Last modified",

  "session.notify.label": "Chat notifications",
  "session.notify.on": "Notifies by {{channels}}",
  "session.notify.off": "Notifications off for this chat",
  "session.notify.blocked": "On for this chat, but Agent and Errors notifications are off in Settings",
  "session.notify.failed": "Could not update chat notifications",
  "session.notify.channel.push": "Push",
  "session.notify.channel.push.description": "When this chat finishes or fails",
  "session.notify.channel.email": "Email",
  "session.notify.channel.sms": "Text message",
  "session.notify.channel.contact.description": "When this chat fails or messages you · {{address}}",
  "session.notify.channel.setup": "Add and verify it in Settings",
  "session.notify.channel.settings": "Email and text settings…",

  "session.header.searchFiles": "Search files",
  "session.header.open.copyPath": "Copy path",


  "prompt.loading": "Loading prompt…",
  "terminal.loading": "Loading terminal…",
  "terminal.title": "Terminal",
  "terminal.title.numbered": "Terminal {{number}}",
  "terminal.close": "Close terminal",
  "terminal.connectionLost.title": "Connection Lost",
  "terminal.connectionLost.abnormalClose": "WebSocket closed abnormally: {{code}}",
  "terminal.connectionLost.description":
    "The terminal connection was interrupted. This can happen when the server restarts.",

  "common.closeTab": "Close tab",
  "common.dismiss": "Dismiss",
  "common.moreCountSuffix": " (+{{count}} more)",
  "common.requestFailed": "Request failed",
  "common.moreOptions": "More options",
  "common.rename": "Rename",
  "common.archive": "Archive",
  "common.restore": "Restore",
  "common.delete": "Delete",
  "common.openInNewTab": "Open in new tab",
  "common.openInNewWindow": "Open in new window",
  "sidebar.archive": "Archive",
  "sidebar.archiveEmpty": "No archived chats",
  "sidebar.snoozed": "Snoozed",
  "sidebar.snooze": "Snooze",
  "sidebar.snooze.hours": "{{count}} hours",
  "sidebar.snooze.week": "1 week",
  "sidebar.snooze.bringBack": "Bring back now",
  "sidebar.snooze.returns": "Returns {{time}}",
  "sidebar.session.moveTo": "Move to",
  "sidebar.session.newWorkspace": "New workspace",
  "common.close": "Close",
  "common.loadMore": "Load more",
  "common.showLess": "Show less",
  "common.key.esc": "ESC",
  "common.key.ctrl": "Ctrl",
  "common.key.alt": "Alt",
  "common.key.shift": "Shift",
  "common.key.meta": "Meta",
  "common.key.space": "Space",
  "common.key.backspace": "Backspace",
  "common.key.enter": "Enter",
  "common.key.tab": "Tab",
  "common.key.delete": "Delete",
  "common.key.home": "Home",
  "common.key.end": "End",
  "common.key.pageUp": "Page Up",
  "common.key.pageDown": "Page Down",
  "common.key.insert": "Insert",
  "common.unknown": "unknown",

  "common.time.justNow": "Just now",
  "common.time.minutesAgo.short": "{{count}}m ago",
  "common.time.hoursAgo.short": "{{count}}h ago",
  "common.time.daysAgo.short": "{{count}}d ago",

  "sidebar.nav.projectsAndSessions": "Workspaces and chats",
  "sidebar.attention.needsYou": "Needs you",
  "sidebar.attention.working": "Working",
  "sidebar.attention.collapseWorking": "Collapse working sessions",
  "sidebar.attention.expandWorking": "Expand working sessions",
  "sidebar.attention.automations": "Automations",
  "sidebar.attention.collapseAutomations": "Collapse automation chats",
  "sidebar.attention.expandAutomations": "Expand automation chats",
  "sidebar.attention.oraclesOnly": "Oracles only",
  "sidebar.attention.markDone": "Mark done",



  "settings.general.section.appearance": "Appearance",
  "settings.general.section.notifications": "System notifications",
  "settings.general.row.colorScheme.title": "Color scheme",
  "settings.general.row.colorScheme.description": "Choose whether Kettle follows the system, light, or dark theme",
  "settings.general.row.theme.title": "Theme",
  "settings.general.row.theme.description": "Customise how Kettle is themed.",
  "settings.general.row.reasoningSummaries.title": "Show reasoning summaries",
  "settings.general.row.reasoningSummaries.description": "Display model reasoning summaries in the timeline",


  "settings.general.notifications.agent.title": "Agent",
  "settings.general.notifications.agent.description":
    "Show system notification when a chat with notifications on finishes, or an agent needs your input",
  "settings.general.notifications.permissions.title": "Permissions",
  "settings.general.notifications.permissions.description": "Show system notification when a permission is required",
  "settings.general.notifications.errors.title": "Errors",
  "settings.general.notifications.errors.description": "Show system notification when a chat with notifications on fails",

  "settings.shortcuts.title": "Keyboard shortcuts",
  "settings.shortcuts.reset.button": "Reset to defaults",
  "settings.shortcuts.reset.toast.title": "Shortcuts reset",
  "settings.shortcuts.reset.toast.description": "Keyboard shortcuts have been reset to defaults.",
  "settings.shortcuts.conflict.title": "Shortcut already in use",
  "settings.shortcuts.conflict.description": "{{keybind}} is already assigned to {{titles}}.",
  "settings.shortcuts.pressKeys": "Press keys",

  "settings.providers.title": "Providers",
  "settings.providers.section.connected": "Connected providers",
  "settings.providers.connected.empty": "No connected providers",
  "settings.providers.tag.environment": "Environment",
  "settings.providers.tag.config": "Config",
  "settings.providers.tag.custom": "Custom",
  "settings.providers.tag.other": "Other",
  "settings.permissions.tool.read.title": "Read",
  "settings.permissions.tool.read.description": "Reading a file (matches the file path)",
  "settings.permissions.tool.edit.title": "Edit",
  "settings.permissions.tool.edit.description": "Modify files, including edits, writes, patches, and multi-edits",
  "settings.permissions.tool.glob.title": "Glob",
  "settings.permissions.tool.glob.description": "Match files using glob patterns",
  "settings.permissions.tool.grep.title": "Grep",
  "settings.permissions.tool.grep.description": "Search file contents using regular expressions",
  "settings.permissions.tool.list.title": "List",
  "settings.permissions.tool.list.description": "List files within a directory",
  "settings.permissions.tool.bash.title": "Bash",
  "settings.permissions.tool.bash.description": "Run shell commands",
  "settings.permissions.tool.task.title": "Task",
  "settings.permissions.tool.task.description": "Launch sub-agents",
  "settings.permissions.tool.launch_chat.description": "Start a chat that runs with fewer approvals than this one",
  "settings.permissions.tool.message_chat.description": "Message a chat that runs with fewer approvals than this one",
  "settings.permissions.tool.skill.title": "Skill",
  "settings.permissions.tool.skill.description": "Load a skill by name",
  "settings.permissions.tool.lsp.title": "LSP",
  "settings.permissions.tool.lsp.description": "Run language server queries",
  "settings.permissions.tool.webfetch.title": "Web Fetch",
  "settings.permissions.tool.webfetch.description": "Fetch content from a URL",
  "settings.permissions.tool.websearch.title": "Web Search",
  "settings.permissions.tool.websearch.description": "Search the web",
  "settings.permissions.tool.codesearch.title": "Code Search",
  "settings.permissions.tool.codesearch.description": "Search code on the web",
  "settings.permissions.tool.external_directory.title": "External Directory",
  "settings.permissions.tool.external_directory.description": "Access files outside the project directory",
  "settings.permissions.tool.doom_loop.title": "Doom Loop",
  "settings.permissions.tool.doom_loop.description": "Detect repeated tool calls with identical input",

  "session.copyChat": "Copy chat",
  "session.copyChat.copied": "Chat copied",
  "session.copyChat.failed": "Could not copy chat",
  "session.delete.failed.title": "Failed to delete session",
  "session.delete.title": "Delete session",
  "session.delete.confirm": 'Delete session "{{name}}"?',
  "session.delete.button": "Delete session",

  "workspace.new": "New workspace",
  "workspace.type.local": "local",
  "workspace.type.sandbox": "sandbox",
  "workspace.create.failed.title": "Failed to create workspace",
  "workspace.delete.failed.title": "Couldn't delete workspace",
  "workspace.relocate.failed.title": "Couldn't change workspace folder",
  "workspace.cleanup.failed.title": "Workspace deleted, but local cleanup failed",
  "workspace.error.stillPreparing": "Workspace is still preparing",
}
